import React from 'react';

import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';

import { WDSButton } from 'wanderu-components';
import FlagIcon from 'wanderu-flag-icons';
import { localeToLanguage } from 'wanderu-i18n';

import styles from './Country.scss';

function Country(props) {
    const {
        localeConfig,
        onClick = () => undefined,
    } = props;
    const {
        countryCode,
        countryName,
        defaultLocale,
        locales,
    } = localeConfig;

    function renderCountryInfo() {
        return (
            <>
                <LazyLoad height={14} once>
                    <FlagIcon
                        className={styles.flag}
                        code={countryCode}
                    />
                </LazyLoad>
                <span className={styles.countryContent}>
                    {countryName}
                </span>
            </>
        );
    }

    function handleClick(e, locale) {
        e.preventDefault();
        e.stopPropagation();
        onClick(locale);
    }

    return (
        <>
            {locales.length > 1
                ? (
                    <div
                        className={styles.countryContainer}
                        onClick={(e) => handleClick(e, defaultLocale)}
                    >
                        {renderCountryInfo()}
                        <div className={styles.countryContent}>
                            {locales.map((locale) => (
                                <WDSButton
                                    className={styles.alternateLocale}
                                    key={locale}
                                    onClick={(e) => handleClick(e, locale)}
                                    variant="unstyled"
                                >
                                    {localeToLanguage(locale).toUpperCase()}
                                </WDSButton>
                            ))}
                        </div>
                    </div>
                )
                : (
                    <WDSButton
                        className={styles.countryContainer}
                        onClick={(e) => handleClick(e, defaultLocale)}
                        variant="unstyled"
                    >
                        {renderCountryInfo()}
                    </WDSButton>
                )}
        </>
    );
}

Country.propTypes = {
    localeConfig: PropTypes.object.isRequired,
    onClick: PropTypes.func,
};

export {
    Country,
};

export default Country;
